cleverapps.Tool.extraCurrencyCommands = {
    soft_add1000: function () {
        cleverapps.user.setSoft(cleverapps.user.soft + 1000, false, { event: cleverapps.EVENTS.EARN.OTHER });
    },
    soft_add: function () {
        displayToolPrompt((value) => {
            cleverapps.user.setSoft(cleverapps.user.soft + parseInt(value || "0"), false, { event: cleverapps.EVENTS.EARN.OTHER });
        }, "Enter amount", 0);
    },
    soft_reset: function () {
        cleverapps.user.setSoft(0);
    }
};
